module.exports = __webpack_public_path__ + "img/Blue-L-2@2x.5e135086.png";